import React, { SVGProps } from 'react'

const SvgGoogleWalletIcon = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#34A853"
      fillRule="evenodd"
      d="M47 18.7v-7c0-4-3.3-7.3-7.3-7.3H8.3c-4 0-7.3 3.3-7.3 7.3v7c0 .7.6 1.3 1.3 1.3h43.5c.6 0 1.2-.6 1.2-1.3"
      clipRule="evenodd"
    />
    <path
      fill="#FBBC04"
      fillRule="evenodd"
      d="M47 24.9v-7c0-4-3.3-7.3-7.3-7.3H8.3c-4 0-7.3 3.3-7.3 7.3v7c0 .7.6 1.3 1.3 1.3h43.5c.6-.1 1.2-.7 1.2-1.3"
      clipRule="evenodd"
    />
    <path
      fill="#EA4335"
      fillRule="evenodd"
      d="M47 31v-7c0-4-3.3-7.3-7.3-7.3H8.3C4.3 16.7 1 20 1 24v7c0 .7.6 1.3 1.3 1.3h43.5c.6-.1 1.2-.6 1.2-1.3"
      clipRule="evenodd"
    />
    <path
      fill="#4285F4"
      fillRule="evenodd"
      d="M30.2 27.6 1 20.9v15.4c0 4 3.3 7.3 7.3 7.3h31.4c4 0 7.3-3.3 7.3-7.3V20.5l-7 5.1c-2.8 2.1-6.4 2.8-9.8 2"
      clipRule="evenodd"
    />
  </svg>
)

export default SvgGoogleWalletIcon
